import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Switch } from '@rsos/components/capstone/base';
import { selectCapstoneAudioSettingsForFeature } from '@rsos/sinatra/src/selectors/selectAudioSettings';
import useIsIRP from '@rsos/utils/useIsIRP';
import { usePatchAudioSettings } from '../../app/patchAudioSettings';
import { SettingsManagementDispatch } from '../../store';
import SoundSelect from '../SoundSelect';
import { trackToggleSoundOnOff } from '../audioSettingsTrackings';
import styles from '../settings.module.css';

export const InitialTextMessageAudioSettings = () => {
  const dispatch = useDispatch<SettingsManagementDispatch>();
  const smsSettings = useSelector(selectCapstoneAudioSettingsForFeature('sms'));

  const { sound_on: isSoundOn, tone } = smsSettings;

  const patchAudioSettings = usePatchAudioSettings('sms');
  const updateAudioSettings = (update: Partial<typeof smsSettings>) => {
    dispatch(patchAudioSettings(update));
  };

  const { irpVersion } = useIsIRP();
  const toggleSoundOn = () => {
    updateAudioSettings({ sound_on: !isSoundOn });
    trackToggleSoundOnOff(irpVersion, isSoundOn, 'sms');
  };

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.cardTitle}>Initial Inbound Text</div>
        <div className={styles.cardDescription}>
          Notify your agents with sound when a new text first appears in the
          queue. All users will receive a banner notification by default.
        </div>
      </div>
      <div>
        <div className={styles.inputLabel}>All Users</div>
        <div className={styles.inputDescription}>
          Configure sound notifications for initial inbound texts for all users.
        </div>
      </div>
      <div className={styles.soundBlock}>
        <span>Sound Notification</span>
        <Switch onOffLabel onClick={toggleSoundOn} isOn={isSoundOn} />
      </div>
      <SoundSelect
        isSoundOn={isSoundOn}
        type={'sms'}
        tone={tone}
        updateAudioSettings={updateAudioSettings}
      />
    </div>
  );
};
